import React from 'react';
import { ColorPicker, Tooltip } from 'antd';
import { useAppStore } from '../../store/useAppStore';
import { viewportActions } from '../../viewportActions';
import { C } from '../../theme';
import { sep, rowStyle, actionBtn, toolBtn } from './toolbarStyles';

interface Props {
  colorPanelRender: (node: React.ReactNode, info: any) => React.ReactNode;
  handleBrushColorChange: (color: any, info: any) => void;
}

const FillContextStrip: React.FC<Props> = ({ colorPanelRender, handleBrushColorChange }) => {
  const pickerValue      = useAppStore((s) => s.pickerValue);
  const fillFloodMode    = useAppStore((s) => s.fillFloodMode);
  const setFillFloodMode = useAppStore((s) => s.setFillFloodMode);
  const fillTolerance    = useAppStore((s) => s.fillTolerance);
  const setFillTolerance = useAppStore((s) => s.setFillTolerance);

  return (
    <div className="tb-row" style={{ ...rowStyle, minHeight: 28, borderLeft: '3px solid #4ade80', paddingLeft: 5 }}>
      <ColorPicker
        disabledAlpha
        mode={['single', 'gradient']}
        value={pickerValue}
        onChange={handleBrushColorChange}
        panelRender={colorPanelRender}
        size="small"
      />
      <div style={sep} />
      <Tooltip title="Fill only the contiguous island of similar color from the click point" placement="bottom">
        <button
          onClick={() => setFillFloodMode('island')}
          style={toolBtn(fillFloodMode === 'island', 'green')}
        >
          Island
        </button>
      </Tooltip>
      <Tooltip title="Fill all pixels of similar color across the entire layer" placement="bottom">
        <button
          onClick={() => setFillFloodMode('noncontiguous')}
          style={toolBtn(fillFloodMode === 'noncontiguous', 'green')}
        >
          Non-Contiguous
        </button>
      </Tooltip>
      <Tooltip title="Fill the entire layer, ignoring existing content and tolerance" placement="bottom">
        <button
          onClick={() => setFillFloodMode('global')}
          style={toolBtn(fillFloodMode === 'global', 'green')}
        >
          Global
        </button>
      </Tooltip>
      <div style={sep} />
      <Tooltip title={`color tolerance: ${fillTolerance} — how similar a color must be to be filled`} placement="bottom">
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <span style={{ fontSize: 11, color: C.textSecondary, flexShrink: 0 }}>Tol</span>
          <input
            type="range"
            min={0}
            max={100}
            step={1}
            value={fillTolerance}
            onChange={(e) => setFillTolerance(Number(e.target.value))}
            style={{ width: 72, accentColor: '#4ade80', cursor: 'pointer' }}
          />
          <span style={{ fontSize: 11, color: C.textSecondary, minWidth: 22, textAlign: 'right' }}>{fillTolerance}</span>
        </div>
      </Tooltip>
    </div>
  );
};

export default React.memo(FillContextStrip);

